// extracted by mini-css-extract-plugin
module.exports = {"imgWrapper":"FinalPcbRow_imgWrapper__202Yi","modRow":"FinalPcbRow_modRow__9GQZ-"};